import { styled } from 'solid-styled-components';
import theme, { fontFamilyAtosRegular } from '../../style/theme';

export const StyledFormDiv = styled.div`
    display: flex;
    gap:1rem;
    ${theme.mediaQueries.mobileMax}{
        display: flex;
        flex-direction: column;
    }
`;

export const DropdownWrapper = styled.div`
    ${theme.mediaQueries.mobileMax}{
        display: flex;
        flex-direction: column;
    }
`;

type StyledTextAreaProps = {
    hasErrors?: boolean;
};
export const StyledTextArea = styled.textarea<StyledTextAreaProps>`
    width: 100%;
    font-size: ${theme.fontSize.normal};
    font-family: ${fontFamilyAtosRegular};
    border-radius: 5px;
    padding: 1rem;
    resize: none;
    border: ${p => p.hasErrors ? `1px solid ${theme.colors.text.pink}` : '1px solid #707070'};
`;

export const StyledPolicyWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
`;

export const FormLink = styled.a`
    margin-left: 0.36rem;
    color: red;
`;
export const PolicyDiv = styled.div`
`;

export const FormSelect = styled.select`
    padding: 0.71rem;
`;

export const FieldWrapper = styled.div`
    display: flex;
    justify-content: end;
    width: 37.7rem;
`;

export const FormButtonWrapper = styled.div`
    ${theme.mediaQueries.mobileMax}{
        display: flex;
        justify-content: center;
    }
`;

export const StyledForm = styled.div`
    width: 100%;
    max-width: 65rem;
    scroll-margin-top: 10rem; /* To make sure the header doesnt block the step numbers. */
    &:not(:first-child) {
        margin-top: 5rem;
    }
`;

export const StyledFormWrapper = styled.form`
    ${theme.mediaQueries.mobileMax}{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0px;
    }
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 4rem;
`;

export const StyledFieldErrorMessage = styled.div`
    color: ${theme.colors.text.pink};
    font-family: ${fontFamilyAtosRegular};
    font-size: 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.3rem;
    margin-top: 0.3rem;
`;

export const StyledStepOverview = styled.div<{ percentCompleted: number, width: string }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
    position: relative;
    margin-bottom: 6.5rem;
    margin-inline: auto;
    width: ${p => p.width};

    ${theme.containerQueries.tabletMax} {
        width: 100%;
        margin-bottom: 4rem;
    }

    &::before {
        content: '';
        width: 100%;
        height: 4px;
        background-color: ${theme.palette.lightGray};
        position: absolute;
        bottom: calc(50% - 2px);
        left: 0;
        z-index: 0;
    }

    &::after {
        content: '';
        width: ${p => p.percentCompleted}%;
        height: 4px;
        background-color: ${theme.palette.red};
        position: absolute;
        bottom: calc(50% - 2px);
        left: 0;
        z-index: 0;
        transition: width 0.2s linear;
    }
`;

export const StyledStepOverviewItem = styled.div <{
    isActive: boolean;
    isCompleted: boolean;
}>`
    z-index: 1;
    width: 4.5rem;
    height: 4.5rem;
    min-width: 4.5rem;
    min-height: 4.5rem;
    max-width: 4.5rem;
    max-height: 4.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border-radius: 50%;
    background-color: ${p => p.isCompleted 
        ? theme.palette.red 
        : p.isActive ? theme.palette.white : theme.palette.white};
    color: ${p => p.isCompleted ? theme.palette.white : theme.palette.darkGray};
    border: 3px solid ${p => p.isActive || p.isCompleted ? theme.palette.red : theme.palette.lightGray};
    transition: background-color 0.2s ease ${p => p.isCompleted ? '0s' : '0.2s'}, color 0.2s ease ${p => p.isCompleted ? '0s' : '0.2s'}, border-color 0.2s ease ${p => p.isCompleted ? '0s' : '0.2s'};
`;

export const StyledStepOverviewItemContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
`;

export const StyledStepLabel = styled.div`
    position: absolute;
    top: 4.5rem;
    margin-top: 0.5rem;
    width: max-content;
    text-align: center;
    max-width: 12rem;

    ${theme.mediaQueries.tabletMax} {
        display: none;
    }
`;

export const StyledNavigationButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
`;

export const StyledSubmitButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    margin-left: auto;
    align-items: center;
`;

export const StyledFormErrorMessage = styled.div`
    height: 4rem;
    display: flex;
    align-items: center;
    margin-inline: auto;
    color: ${theme.colors.text.red};
    font-size: 16px;
    font-family: ${fontFamilyAtosRegular};
`;

export const StyledLoadingSpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    height: 4rem;
    margin-inline: auto;
`;

